var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 1.75H16.5V0.875C16.5 0.392 16.1089 0 15.625 0C15.1411 0 14.75 0.392 14.75 0.875V1.75H7.75V0.875C7.75 0.392 7.35887 0 6.875 0C6.39113 0 6 0.392 6 0.875V1.75H5.125C2.71263 1.75 0.75 3.71263 0.75 6.125V16.625C0.75 19.0374 2.71263 21 5.125 21H17.375C19.7874 21 21.75 19.0374 21.75 16.625V6.125C21.75 3.71263 19.7874 1.75 17.375 1.75ZM5.125 3.5H17.375C18.8223 3.5 20 4.67775 20 6.125V7H2.5V6.125C2.5 4.67775 3.67775 3.5 5.125 3.5ZM17.375 19.25H5.125C3.67775 19.25 2.5 18.0723 2.5 16.625V8.75H20V16.625C20 18.0723 18.8223 19.25 17.375 19.25ZM17.375 12.25C17.375 12.733 16.9839 13.125 16.5 13.125H6C5.51613 13.125 5.125 12.733 5.125 12.25C5.125 11.767 5.51613 11.375 6 11.375H16.5C16.9839 11.375 17.375 11.767 17.375 12.25ZM11.25 15.75C11.25 16.233 10.8589 16.625 10.375 16.625H6C5.51613 16.625 5.125 16.233 5.125 15.75C5.125 15.267 5.51613 14.875 6 14.875H10.375C10.8589 14.875 11.25 15.267 11.25 15.75Z",
    fill: "#EE4E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.acd184a589ede3eaf36752f564bf1171.svg";
export { ForwardRef as ReactComponent };